// src/stone/icons/Pos2X.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Pos2X = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M31.667 5H33a2 2 0 0 1 2 2v26a2 2 0 0 1-2 2h-1.333zM9 7.667a2 2 0 0 1 2-2h14.667a2 2 0 0 1 2 2v9.666a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2zm16.667 0H11v9.666h14.667zM9.833 23.333a1 1 0 0 1 1-1H12.5a1 1 0 1 1 0 2h-1.667a1 1 0 0 1-1-1M16.5 23.333a1 1 0 0 1 1-1h1.667a1 1 0 1 1 0 2H17.5a1 1 0 0 1-1-1M9.833 28.333a1 1 0 0 1 1-1H12.5a1 1 0 1 1 0 2h-1.667a1 1 0 0 1-1-1M9.833 33.333a1 1 0 0 1 1-1H12.5a1 1 0 1 1 0 2h-1.667a1 1 0 0 1-1-1M16.5 28.333a1 1 0 0 1 1-1h1.667a1 1 0 1 1 0 2H17.5a1 1 0 0 1-1-1M16.5 33.333a1 1 0 0 1 1-1h1.667a1 1 0 1 1 0 2H17.5a1 1 0 0 1-1-1M23.167 23.333a1 1 0 0 1 1-1h1.666a1 1 0 1 1 0 2h-1.666a1 1 0 0 1-1-1M23.167 28.333a1 1 0 0 1 1-1h1.666a1 1 0 1 1 0 2h-1.666a1 1 0 0 1-1-1M23.167 33.333a1 1 0 0 1 1-1h1.666a1 1 0 1 1 0 2h-1.666a1 1 0 0 1-1-1" }),
      /* @__PURE__ */ jsx("path", { d: "M4.645 2.882C4.899 1.508 6.108.667 7.39.667h21.887c1.282 0 2.49.84 2.745 2.215.288 1.558.645 4.374.645 8.785 0 5.832-.626 19.749-.864 24.814a2.993 2.993 0 0 1-2.993 2.852H7.857a2.993 2.993 0 0 1-2.994-2.852C4.626 31.416 4 17.499 4 11.667c0-4.41.356-7.227.645-8.785m2.745-.215c-.436 0-.72.264-.779.579C6.348 4.67 6 7.363 6 11.666c0 5.775.623 19.634.86 24.721.026.53.462.946.997.946H28.81a.994.994 0 0 0 .996-.946c.238-5.087.86-18.946.86-24.72 0-4.304-.347-6.997-.61-8.421-.059-.315-.344-.58-.78-.58z" })
    ]
  }
);
var Pos2X_default = Pos2X;

export {
  Pos2X_default
};
